import React, { useEffect, useState } from "react";

import { Close as CloseIcon } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { makeStyles } from "tss-react/mui";

import { weeklyDates } from "../utils/useWeeklyRatingGraph";

const useStyles = makeStyles()(() => ({
  closeButton: {
    position: "absolute",
    top: 12,
    right: 16,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 24,
  },
  label: {
    color: "#7D8797",
    fontFamily: "Mulish",
    fontSize: 14,
    fontWeight: 600,
  },
  downloadButton: {
    fontFamily: "Mulish",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: -0.5,
    alignSelf: "center",
    width: "30%",
  },
}));

interface MealRatingReportDownloadDialogProps {
  isOpen: boolean;
  selectedDate: string;
  onClose?: () => void;
  onDownload?: (startDate: Date, endDate: Date) => void;
}

const MealRatingReportDownloadDialog: React.FC<MealRatingReportDownloadDialogProps> =
  ({ isOpen, selectedDate, onClose, onDownload }) => {
    const { classes } = useStyles();
    const dates = weeklyDates(selectedDate);
    const initialStartDate = dates[0];
    const initialEndDate = dates[6];
    const [startDate, setStartDate] = useState<Date>(initialStartDate);
    const [endDate, setEndDate] = useState<Date>(initialEndDate);

    useEffect(() => {
      setStartDate(initialStartDate);
      setEndDate(initialEndDate);
    }, [selectedDate]);

    const handleClickDownload = () => {
      if (!startDate && !endDate) return;
      onDownload?.(startDate, endDate);
    };

    return (
      <Dialog open={isOpen} fullWidth onClose={onClose}>
        <DialogTitle>Download Report</DialogTitle>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <DialogContent className={classes.dialogContent}>
          <Typography className={classes.label}>Start Date</Typography>
          <Box height={8} />
          <DatePicker
            value={startDate}
            format="dd MMM, yyyy"
            onChange={(value) => setStartDate(value as Date)}
          />
          <Box height={24} />
          <Typography className={classes.label}>End Date</Typography>
          <Box height={8} />
          <DatePicker
            value={endDate}
            format="dd MMM, yyyy"
            onChange={(value) => setEndDate(value as Date)}
          />
          <Box height={32} />
          <Button
            size="large"
            className={classes.downloadButton}
            disabled={startDate > endDate}
            onClick={handleClickDownload}
          >
            Download
          </Button>
        </DialogContent>
      </Dialog>
    );
  };

export default MealRatingReportDownloadDialog;
